import Vue from "vue"
import { Component, Prop, Emit } from "vue-property-decorator"
import { IPriceListViewModel, IContractViewModel } from "../../../../../../Scripts/inpulse/I4UViewModels";
import { TarificationIdEnum } from "../../../../../../Scripts/inpulse/CommonEnums";
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { CommonFormatUtils } from "../../../../../../Scripts/inpulse/FormatUtils";
import { PriceListUtils } from "../../../../../../Scripts/inpulse/PriceListUtils";
import ProductionType from "./production-type.vue"
import { IContractSettings } from "../../../new-contract-vuex-store";

library.add(faCheck)
Vue.component('font-awesome-icon', FontAwesomeIcon)

@Component({
    components: {
        ProductionType
    }
})

export default class PriceList extends Vue {
    @Prop()
    priceList: IPriceListViewModel;
    @Prop({ default: true })
    actions: boolean;
    @Prop()
    isSelected: boolean;
    @Prop()
    showVat: boolean;
    @Prop()
    productId: number;
    @Prop()
    productName: string;

    @Emit()
    selected(priceList: IPriceListViewModel) { }

    TarificationIdEnum: typeof TarificationIdEnum = TarificationIdEnum;

    get contractSettings(): IContractSettings { return this.$store.state.contractSettings; }
    get contract(): IContractViewModel { return this.$store.state.contract; }
    get tarification(): TarificationIdEnum { return this.$store.state.contract.TarificationId; }
    get energy1(): number { return this.$store.state.contract.Energy1; }
    get energy2(): number { return this.$store.state.contract.Energy2; }
    get selectedServiceProducts(): string[] { return this.$store.state.selectedServiceProducts; }
    get offerProducts(): string[] { return this.$store.state.offerProducts; }

    get offerRequest(): boolean { return this.$store.state.offerRequest; }
    //}
    //get isPriimaPlusPriceList(): boolean {
    //    return this.contractSettings.PriimaPlusProductId && this.contractSettings.PriimaPlusProductId > 0
    //        && this.productId == this.contractSettings.PriimaPlusProductId;
    //}
    


    setSelectedServiceProducts(payload: { selectedServiceProducts: string[] }) { return this.$store.dispatch("setSelectedServiceProducts", payload); }
    selectedServiceProducts2: string[];


    constructor() {
        super();
        if (this.selectedServiceProducts2 === undefined) {
            this.selectedServiceProducts2 = this.selectedServiceProducts;
        }
    }

    created(): void {
        if (this.selectedServiceProducts2 === undefined) {
            this.selectedServiceProducts2 = this.selectedServiceProducts;
        }
    }

    showPriima(priceList: IPriceListViewModel): boolean {
        if (priceList.Name.toLowerCase() == "priima") {
            return true
        }
        return false;
    }

    changeServiceProduct(payload: { key: string, value: string }) { return this.$store.dispatch("changeValue", payload); }

    formatDuration(contract: IContractViewModel, priceList: IPriceListViewModel) {
        return CommonFormatUtils.formatDuration(contract, priceList, this.$i18n.locale);
    }
    
    getFixedPrice(price: number, digits: number) {
        return PriceListUtils.getFixedPrice(price, digits);
    }

    showPriceEstimate(priceList: IPriceListViewModel) {
        if (priceList.Name != "Optimi takuu") {
            return false;
        }
        return PriceListUtils.showPriceEstimate(priceList);
    }
    priceEstimate(priceLists: IPriceListViewModel) {
        return this.calculatePriceEstimate(priceLists);
    }

    calculatePriceEstimate(priceList: IPriceListViewModel) {
        //return PriceListUtils.calculatePriceEstimate(priceList, this.showVat, this.tarification, this.energy1, this.energy2);
        let priceEstimate = PriceListUtils.calculatePriceEstimate(this.priceList, this.showVat, this.tarification, this.energy1, this.energy2); //includes mandatory service products
        //Add costs of selected optional service products
        let extraCost = 0.0;
        if (this.selectedServiceProducts.length > 0) {
            for (let ind = 0; ind < this.priceList.PriceListServiceProducts.length; ind++) {
                if (this.priceList.PriceListServiceProducts[ind].PriceListServiceProductType === 1) {
                    const sp = this.priceList.PriceListServiceProducts[ind];
                    const key = this.priceList.Id.toFixed() + ";" + sp.ServicePriceList.ExternalPriceListId;
                    const index = this.selectedServiceProducts2.indexOf(key, 0);
                    if (index > -1) { //service product was found among the selected ones
                        extraCost += PriceListUtils.calculateServiceProductPrice(sp.ServicePriceList.ProductComponents[0], this.showVat, this.tarification, this.energy1, this.energy2);
                    }
                }
            }
        }
        priceEstimate = priceEstimate + extraCost;
        return this.getFixedPrice(priceEstimate, 2);
    }
    //SQI4U-1113 this just launches some change event that fixes the maxvalues, the max values are set in metering-point-information.ts. Added this function call to price-list.vue line 188.
    updateStartDatepicker() {
        this.$store.dispatch("changeValue", { key: "StartDate", value: moment(String(this.contract.StartDate)).format('DD.MM.YYYY') });
    }
    //SQI4U-1113 end

    serviceProductSelectionChanged(e: Event) {
        const inputStr = (<HTMLInputElement>e.target).value;
        if (this.selectedServiceProducts2 === undefined) {
            this.selectedServiceProducts2 = [];
        }
        console.log("serviceProductSelectionChanged " + inputStr);
        const el = (<HTMLInputElement>e.target);
        let value = inputStr + ";";
        if (el.checked) {
            console.log("Valittu");
            value = value + "1";
            this.selectedServiceProducts2.push(inputStr);
        }
        else {
            console.log("Ei valittu");
            value = value + "0";
            const index = this.selectedServiceProducts2.indexOf(inputStr, 0);
            if (index > -1) {
                this.selectedServiceProducts2.splice(index, 1);
            }
        }
        this.setSelectedServiceProducts({ selectedServiceProducts: this.selectedServiceProducts2 }).then(() => {
            console.log("setSelectedServiceProducts done");
            const priceEstimate = this.calculatePriceEstimate(this.priceList);
            console.log("Set cost estimate " + priceEstimate + "to: " + "#priceEstimatePrice" + this.priceList.Id.toFixed());
            $("#priceEstimatePrice" + this.priceList.Id.toFixed()).html(priceEstimate);
        });

        this.changeServiceProduct({ key: "ServiceProduct", value: value }).then(() => {
            console.log("service product changed");
        });
    }
    isServiceProductSelected(priceListId: number, serviceProductExternalPriceListId: string): boolean {
        if (this.selectedServiceProducts2 === undefined) {
            this.selectedServiceProducts2 = this.selectedServiceProducts;
            if (this.selectedServiceProducts2 === undefined) {
                return false;
            }
        }
        console.log("this.selectedServiceProducts2.length: " + this.selectedServiceProducts2.length);
        const index = this.selectedServiceProducts2.indexOf(priceListId.toFixed() + ";" + serviceProductExternalPriceListId, 0);
        if (index > -1) {
            return true;
        }
        else {
            return false;
        }
    }

    //showProductionTypeSelection(): boolean {
    //    if (this.isPriimaPriceList || this.isPriimaPlusPriceList) {
    //        return true;
    //    }
    //    return false;
    //}

    isOptimi() {
        return false;
        //return this.productName.indexOf("optimi") > 0;
    }

    privateShowFuture: boolean = false;
    toggleNextMonth() {
        this.privateShowFuture = !this.privateShowFuture;
        if (this.privateShowFuture) {
            $("#second-section-" + this.priceList.Id).removeClass("display-long").addClass("display-short");;
            $("#first-section-" + this.priceList.Id).removeClass("display-short").addClass("display-long");            
        }
        else {
            $("#second-section-" + this.priceList.Id).removeClass("display-short").addClass("display-long");;
            $("#first-section-" + this.priceList.Id).removeClass("display-long").addClass("display-short");            
        }
    }

    showSelectButton(): boolean {
        let show = true;
        if (this.offerRequest) {
            show = false;
        }
        return show;
    }

    showOfferSelectButton(): boolean {
        let show = false;
        if (this.offerRequest) {
            show = true;
        }
        return show;
    }

    selectedOfferProduct(priceList: IPriceListViewModel) {
        let prod = "pricelist-" + this.productId.toString() + "-" + priceList.Id.toString();
        this.$store.dispatch("setOfferProduct", { selectedProduct: prod });
    }

    isSelectedProduct() {
        var result = false;
        let prod = "pricelist-" + this.productId.toString() + "-" + this.priceList.Id.toString();
        if (this.offerProducts.indexOf(prod) > -1) {
            result = true;
        }
        return result;
    };
}